<template>
  <div id="fc-supplies-inventory">
    <div class="flex items-center justify-between mb-4">
      <h2>{{$t('Supplies Inventory')}}</h2>
      <span class="font-medium text-primary cursor-pointer">
        <vs-button
          @click="openInventoryIModal('Add')"
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          size="large"
        >
        </vs-button>
      </span>
    </div>
    <div class="vx-row">
      <div v-for="supplyItem in inventoryItems" :key="supplyItem.id || supplyItem.package_size.id" class="vx-col w-full lg:w-1/4 mb-base">
        <statistics-card-line v-if="supplyItem.package_size.id !== 5"
          hideChart
          :dataLoading="inventoryItemsLoading"
          icon="PackageIcon"
          :statistic="supplyItem.count"
          :statisticTitle="supplyItem.package_size.name"
        ></statistics-card-line>
      </div>
    </div>
    <shipblu-table
      multiple
      v-model="selected"
      :sst="true"
      :max-items="maximumItems"
      pagination
      :data="inventoryTransactions"
      :tableLoader="tableLoader"
      :hideHeader="true"
    >
      
      <template slot="thead">
        <shipblu-th>{{$t('Date')}}</shipblu-th>
        <shipblu-th>{{$t('Type')}}</shipblu-th>
        <shipblu-th>{{$t('Package Size')}}</shipblu-th>
        <shipblu-th>{{$t('Count')}}</shipblu-th>
        <shipblu-th>{{$t('Reference Number')}}</shipblu-th>
        <shipblu-th>{{$t('By')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td class="order-4" :data="data[indextr].created">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Date')}}</p>
            <p class="sm:text-base text-sm">
              {{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}
            </p>
          </shipblu-td>

          <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].package">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Type')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].type }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].package">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Package Size')}}</p>
            <p class="sm:text-base text-sm">
              {{ getPackageSizeName(data[indextr]) }}
            </p>
          </shipblu-td>
          
          <shipblu-td class="order-7" :data="data[indextr].count">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Count')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].count }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-9" :data="data[indextr].referenceNumber">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Reference Number')}}</p>
            <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50" v-on:click.stop>
              {{ data[indextr].reference_number }}
            </div>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].by">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('By')}}</p>
            <p class="sm:text-base text-sm" v-if="data[indextr].by">{{ getByName(data[indextr].by) }}</p>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    <add-supplies-inventory :type="type" :inventoryItems="inventoryItems" :inventory="inventory" :inventoryModal="inventoryModal"
    @inventoryModal="inventoryModal = $event" @loadInventory="loadInventory"></add-supplies-inventory>
  </div>
</template>

<script>
import i18nData from '../../i18n/i18nData.js'
import AddSuppliesInventory from './components/AddSuppliesInventory.vue'
import { sendFulfillmentRequest }  from '../../http/axios/requestHelper.js'
import StatisticsCardLine from '../../components/statistics-cards/StatisticsCardLine.vue'
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'

const fulfillmentCenterCode = 'CAI-DW'
const inventoryShortCodeOrder = ['S-FLY', 'M-FLY', 'L-FLY', 'XL-FLY', 'S-BOX', 'M-BOX', 'L-BOX']

export default {
  data () {
    return {
      selected: [],
      inventory: {},
      inventoryModal: false,
      inventoryItems: [],
      inventoryItemsLoading: false,
      inventoryTransactions: [],
      deleteData: {},
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      offset: 0,
      totalRows: 0,
      tableLoader: false,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      type: ''
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadInventoryTransaction()
    }
  },
  methods: {
    getPackageSizeName (transaction) {
      const inventory = transaction.fulfillment_center_supplies_inventory || transaction.supplies_inventory || transaction.warehouse_supplies_inventory
      const packageSize = (inventory && inventory.package_size) || transaction.package_size
      return packageSize && packageSize.name ? packageSize.name : ''
    },
    getByName (by) {
      return typeof by === 'object' ? `${by.first_name || ''} ${by.last_name || ''}`.trim() : by
    },
    sortInventoryItems (items) {
      return items.sort((firstItem, secondItem) => {
        const firstShortCode = firstItem.package_size && firstItem.package_size.short_code ? firstItem.package_size.short_code : ''
        const secondShortCode = secondItem.package_size && secondItem.package_size.short_code ? secondItem.package_size.short_code : ''
        const firstIndex = inventoryShortCodeOrder.indexOf(firstShortCode)
        const secondIndex = inventoryShortCodeOrder.indexOf(secondShortCode)
        const normalizedFirstIndex = firstIndex === -1 ? inventoryShortCodeOrder.length : firstIndex
        const normalizedSecondIndex = secondIndex === -1 ? inventoryShortCodeOrder.length : secondIndex

        if (normalizedFirstIndex !== normalizedSecondIndex) {
          return normalizedFirstIndex - normalizedSecondIndex
        }

        return firstShortCode.localeCompare(secondShortCode)
      })
    },
    loadInventory () {
      this.inventoryItemsLoading = true
      sendFulfillmentRequest(true, false, this, `api/v1/fc/fulfillment-centers/${fulfillmentCenterCode}/supplies-inventory/`, 'get', null, true,
        (response) => {
          this.inventoryItems = this.sortInventoryItems(response.data.results.filter(element => element.package_size.id !== 5))
          this.loadInventoryTransaction()
          this.inventoryItemsLoading = false
        }
      )
    },
    loadInventoryTransaction () {
      this.tableLoader = true
      sendFulfillmentRequest(true, false, this, `api/v1/fc/fulfillment-centers/${fulfillmentCenterCode}/supplies-inventory/transactions/?offset=${this.offset}&limit=${this.maximumItems}`, 'get', null, true,
        (response) => {
          this.inventoryTransactions = response.data.results
          this.tableLoader = false
          this.totalRows = response.data.count
        }
      )
    },
    openInventoryIModal (type, data) {
      this.type = type
      this.inventoryModal = true
      if (type === 'Add') {
        this.inventory = {
          name: '',
          count: '',
          package_size: ''
        }
      } else {
        this.inventory = data
      }
    },
    deleteInventoryItem (data) {
      this.deleteData = data
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      sendFulfillmentRequest(false, false, this, `api/v1/fc/fulfillment-centers/${fulfillmentCenterCode}/supplies-inventory/${this.deleteData.id}/`, 'delete', null, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Inventory item'] + i18nData[this.$i18n.locale][' has been deleted successfully!'],
            position: 'top-center'
          })
          this.loadInventory()
        }
      )
    }
  },
  components: {
    AddSuppliesInventory,
    StatisticsCardLine,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadInventory()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>

<style lang="scss">
.con-pagination-table{
  display: none;
}
</style>